



// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';

// const Bird = () => {
//   const tasks = useSelector((state) => state.tasks);
//   const subjects = useSelector((state) => state.classes.subjects);
//   const navigate = useNavigate();

//   const totalTasks = tasks.length;
//   const pendingTasks = tasks.filter((t) => !t.completed).length;
//   const today = new Date().toISOString().split('T')[0];
//   const todaysTasks = tasks.filter(
//     (t) => !t.completed && t.dueDate === today
//   );

//   const [text, setText] = useState('');
//   const fullText = 'meaningful milestones.';
//   const [index, setIndex] = useState(0);
//   const [direction, setDirection] = useState(1);
//   const [colorToggle, setColorToggle] = useState(true);

//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       if (direction === 1) {
//         if (index < fullText.length) {
//           setText(fullText.slice(0, index + 1));
//           setIndex((prev) => prev + 1);
//         } else {
//           setDirection(-1);
//           setColorToggle((prev) => !prev);
//         }
//       } else {
//         if (index > 0) {
//           setText(fullText.slice(0, index - 1));
//           setIndex((prev) => prev - 1);
//         } else {
//           setDirection(1);
//         }
//       }
//     }, 80);
//     return () => clearTimeout(timeout);
//   }, [index, direction]);

//   return (
//     <div
//       className="w-full min-h-screen bg-cover bg-center relative"
//       style={{ backgroundImage: `url('/your-background.jpg')` }} // replace with actual path
//     >
//       <div className="absolute top-4 left-4 sm:top-10 sm:left-10 w-full max-w-xs sm:max-w-sm backdrop-blur-sm border border-blue-500 rounded-lg p-4 sm:p-6 space-y-3 sm:space-y-4 shadow-md">
//         <h2 className="text-lg sm:text-xl font-semibold text-gray-900 tracking-tight border-b pb-2">Quick Overview</h2>

//         <div className="space-y-1 text-xs sm:text-sm text-gray-800">
//           <div className="flex justify-between">
//             <span>Total Tasks:</span>
//             <span className="font-medium text-gray-900">{totalTasks}</span>
//           </div>
//           <div className="flex justify-between">
//             <span>Pending Tasks:</span>
//             <span className="font-medium text-yellow-700">{pendingTasks}</span>
//           </div>
//           <div className="flex justify-between">
//             <span>Subjects:</span>
//             <span className="font-medium text-green-700">{subjects.length}</span>
//           </div>
//         </div>

//         <div className="pt-2">
//           <h3 className="text-sm sm:text-md font-semibold text-gray-900 mb-1 border-b pb-1">Today's Tasks</h3>
//           {todaysTasks.length > 0 ? (
//             <ul className="list-disc list-inside text-xs sm:text-sm text-gray-800">
//               {todaysTasks.map((task) => (
//                 <li key={task.id}>{task.title}</li>
//               ))}
//             </ul>
//           ) : (
//             <p className="text-xs sm:text-sm text-gray-500 italic">No tasks due today</p>
//           )}
//         </div>

//         <div className="flex flex-col sm:flex-row justify-between gap-2 sm:gap-3 pt-2">
//           <button
//             onClick={() => navigate('/task')}
//             className="flex-1 border border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition text-xs sm:text-sm px-3 sm:px-4 py-2 rounded"
//           >
//             Add Task
//           </button>
//           <button
//             onClick={() => navigate('/classes')}
//             className="flex-1 border border-green-700 text-green-700 hover:bg-green-700 hover:text-white transition text-xs sm:text-sm px-3 sm:px-4 py-2 rounded"
//           >
//             Add Subject
//           </button>
//         </div>
//       </div>

//       {/* Centered Motivational Quote */}
//       <div className="absolute top-[60%] md:top-[30%] left-1/2 sm:right-[40%] sm:left-auto transform -translate-x-1/2 sm:translate-x-1/2 -translate-y-1/2 text-center text-gray-800 text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug font-semibold italic px-4 sm:px-0">
//         <p className="mb-1 sm:mb-0">Turn quiet moments into</p>
//         <p className={colorToggle ? 'text-red-600' : 'text-green-600'}>{text}</p>
//       </div>
//     </div>
//   );
// };

// export default Bird;


import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Bird = () => {
  const tasks = useSelector((state) => state.tasks);
  const subjects = useSelector((state) => state.classes.subjects);
  const navigate = useNavigate();

  const totalTasks = tasks.length;
  const pendingTasks = tasks.filter((t) => !t.completed).length;
  
  // Fixed: Get today's date in local timezone, formatted as YYYY-MM-DD
  const today = new Date();
  const localToday = new Date(today.getTime() - today.getTimezoneOffset() * 60000)
    .toISOString()
    .split('T')[0];
  
  const todaysTasks = tasks.filter(
    (t) => !t.completed && t.dueDate === localToday
  );

  const [text, setText] = useState('');
  const fullText = 'meaningful milestones.';
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const [colorToggle, setColorToggle] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (direction === 1) {
        if (index < fullText.length) {
          setText(fullText.slice(0, index + 1));
          setIndex((prev) => prev + 1);
        } else {
          setDirection(-1);
          setColorToggle((prev) => !prev);
        }
      } else {
        if (index > 0) {
          setText(fullText.slice(0, index - 1));
          setIndex((prev) => prev - 1);
        } else {
          setDirection(1);
        }
      }
    }, 80);
    return () => clearTimeout(timeout);
  }, [index, direction]);

  // Debug: Add console.log to check the values
  console.log('Today:', localToday);
  console.log('Tasks:', tasks.map(t => ({ title: t.title, dueDate: t.dueDate, completed: t.completed })));
  console.log('Today\'s tasks:', todaysTasks);

  return (
    <div
      className="w-full min-h-screen bg-cover bg-center relative"
      style={{ backgroundImage: `url('/your-background.jpg')` }} // replace with actual path
    >
      <div className="absolute top-4 left-4 sm:top-10 sm:left-10 w-full max-w-xs sm:max-w-sm backdrop-blur-sm border border-blue-500 rounded-lg p-4 sm:p-6 space-y-3 sm:space-y-4 shadow-md">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-900 tracking-tight border-b pb-2">Quick Overview</h2>

        <div className="space-y-1 text-xs sm:text-sm text-gray-800">
          <div className="flex justify-between">
            <span>Total Tasks:</span>
            <span className="font-medium text-gray-900">{totalTasks}</span>
          </div>
          <div className="flex justify-between">
            <span>Pending Tasks:</span>
            <span className="font-medium text-yellow-700">{pendingTasks}</span>
          </div>
          <div className="flex justify-between">
            <span>Subjects:</span>
            <span className="font-medium text-green-700">{subjects.length}</span>
          </div>
        </div>

        <div className="pt-2">
          <h3 className="text-sm sm:text-md font-semibold text-gray-900 mb-1 border-b pb-1">Today's Tasks</h3>
          {todaysTasks.length > 0 ? (
            <ul className="list-disc list-inside text-xs sm:text-sm text-gray-800">
              {todaysTasks.map((task) => (
                <li key={task.id}>{task.title}</li>
              ))}
            </ul>
          ) : (
            <p className="text-xs sm:text-sm text-gray-500 italic">No tasks due today</p>
          )}
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-2 sm:gap-3 pt-2">
          <button
            onClick={() => navigate('/task')}
            className="flex-1 border border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition text-xs sm:text-sm px-3 sm:px-4 py-2 rounded"
          >
            Add Task
          </button>
          <button
            onClick={() => navigate('/classes')}
            className="flex-1 border border-green-700 text-green-700 hover:bg-green-700 hover:text-white transition text-xs sm:text-sm px-3 sm:px-4 py-2 rounded"
          >
            Add Subject
          </button>
        </div>
      </div>

      {/* Centered Motivational Quote */}
      <div className="absolute top-[60%] md:top-[30%] left-1/2 sm:right-[40%] sm:left-auto transform -translate-x-1/2 sm:translate-x-1/2 -translate-y-1/2 text-center text-gray-800 text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug font-semibold italic px-4 sm:px-0">
        <p className="mb-1 sm:mb-0">Turn quiet moments into</p>
        <p className={colorToggle ? 'text-red-600' : 'text-green-600'}>{text}</p>
      </div>
    </div>
  );
};

export default Bird;